export function filterReagents(reagents, options) {
  const reagentsKind = options.miscellaneous?.reagentsKind;

  if (reagentsKind === 'nonWorkup') {
    reagents = reagents.filter(
      (reagent) => reagent.kind?.replace(/[^a-z]/gi, '') !== 'workup',
    );
  } else if (reagentsKind === 'onlyWorkup') {
    reagents = reagents.filter(
      (reagent) => reagent.kind?.replace(/[^a-z]/gi, '') === 'workup',
    );
  }
  return reagents;
}
